import { useUserSettings } from '../../utils/use-user-settings';
import { useNavigate } from 'react-router-dom';
import SharedButton from '../../shared/buttons/shared-button';
import { isFeatureEnabled } from '../../utils/feature-flags';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import ArrowForward from '@mui/icons-material/ArrowForward';
import RocketLaunchOutlined from '@mui/icons-material/RocketLaunchOutlined';

interface EnterpriseUpgradeCardProps {
  drawerOpen: boolean;
}

export default function EnterpriseUpgradeCard({
  drawerOpen,
}: EnterpriseUpgradeCardProps) {
  const theme = useTheme();
  const { currentTier, features } = useUserSettings();
  const navigate = useNavigate();
  const enterpriseUpsellEnabled = isFeatureEnabled(
    'enterpriseFeatureUpsellUiReact',
    features
  );

  if (!drawerOpen || currentTier === 'enterprise' || !enterpriseUpsellEnabled) {
    return null;
  }

  return (
    <Card
      variant="outlined"
      sx={{
        mx: 2,
        mt: 2,
        p: 1.5,
        borderRadius: 2,
        borderColor:
          theme.palette.mode === 'light'
            ? theme.palette.semantic.outline.primary
            : theme.palette.semantic.text.title3,
        backgroundColor: theme.palette.semantic.upsellAds.bg1,
        boxShadow: 'none',
      }}
    >
      <Stack spacing={2} flexDirection="column">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 600,
              lineHeight: 1.35,
              color: theme.palette.semantic.text.title3,
            }}
          >
            Upgrade to gPanel
            <br />
            Enterprise
          </Typography>

          <RocketLaunchOutlined
            sx={{
              fontSize: 26,
              color: theme.palette.semantic.icon.accent,
              transform: 'rotate(-8deg)',
              flexShrink: 0,
            }}
          />
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={1}
        >
          <Typography
            variant="body2"
            sx={{
              lineHeight: 1.55,
              color: theme.palette.semantic.text.body,
              flex: 'wrap',
              textWrap: 'wrap',
            }}
          >
            Build complex automations and custom integrations in minutes.
          </Typography>
        </Stack>
        <SharedButton
          variant="primary"
          size="small"
          onClick={() => navigate('/rules-engine')}
          startIcon={<ArrowForward />}
          sx={{
            width: '100%',
            borderColor: theme.palette.semantic.icon.accent,
            backgroundColor: theme.palette.semantic.icon.accent,
            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
            '&:hover': {
              backgroundColor: theme.palette.semantic.button.error.hover,
              borderColor: theme.palette.semantic.button.error.hover,
            },
          }}
        >
          Learn More
        </SharedButton>
      </Stack>
    </Card>
  );
}
